export const APP_FOLDER     = '/clnt'; 
// export const APP_FOLDER     = '/demo'; 
// export const BASE_API       = 'http://localhost:8888/uruk/api/'; 
export const BASE_API       = 'https://uruk.mx/api/'; 
// export const BASE_API       = 'https://uruk.mx/demo_api/'; 
export const GEO_API        = 'https://geolocation-db.com/json/fb363670-e22a-11eb-a464-59f706281067';
export const SITE_KEY       = '6LfbZdcZAAAAAPWFi4gTx64RuB2dXhnM4JNvPOhn'; 
export const SECRET_KEY     = '6LfbZdcZAAAAAJ51lisN14AKMRz_hfp-tHUsuOOE'; 